<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="container col-lg-6 col-sm-12 offers-form">
        <h1>Edit Offer</h1>
        <ValidationObserver ref="offerForm">
          <ValidationProvider
            v-slot="{ errors }"
            name="salary"
            rules="required|minNumber:1"
          >
            <v-text-field
              v-model="salary"
              class="offers-label"
              label="Salary"
              prepend-inner-icon="mdi-currency-gbp"
              type="number"
              :error-messages="getErrorMessages(errors)"
            />
          </ValidationProvider>
          <DatePicker
            label="Proposed Start Date"
            :inputValue="startDate"
            :showValidationErrors="showValidationErrors"
            @onChange="setStartDate"
            required
          />
        </ValidationObserver>
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleUpdateOffer" :loading="saving">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import DatePicker from "@/components/common/DatePicker";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { UPDATE_OFFER } from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { formatDate } from "@/utils/time";
import {
  getAmountInApiFormat,
  getAmountInDisplayFormat
} from "@/utils/helpers";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  props: {
    isOpen: Boolean,
    currentOffer: { type: Object, required: true }
  },
  components: {
    DialogFull,
    DatePicker,
    PrimaryButton,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      saving: false,
      showValidationErrors: false,
      salary: getAmountInDisplayFormat(this.currentOffer.salary),
      startDate: this.currentOffer.startDate || ""
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Edit Offer"
      };
    },
    organisation() {
      return this.currentBooking.client.name;
    }
  },
  methods: {
    ...mapActions({
      updateOffer: UPDATE_OFFER
    }),
    async handleUpdateOffer() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.offerForm.validate();
      if (isValid) {
        this.saving = true;
        await this.updateOffer({
          salary: getAmountInApiFormat(this.salary),
          startDate: this.startDate,
          id: this.currentOffer.id
        });
        this.close();
        this.saving = false;
        this.showValidationErrors = false;
      }
    },
    setStartDate(date) {
      this.startDate = formatDate({ date });
    },
    close() {
      this.$emit("close");
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    }
  }
};
</script>

<style lang="scss" scope></style>
